import { AuthService } from '@pw-tech/web-sdk';
import * as Sentry from '@sentry/react';
import log from 'loglevel';
import { isLocalHost } from 'src/constants/constants';

declare global {
  interface Window {
    vplogger: log.Logger;
    PWWebSDK: AuthService;
    initPWAuthWebSDK: (props: any) => void;
    PWAuthWebSDK: any;
  }
}

const vpLogger = log.getLogger('vp-logger');
vpLogger.setDefaultLevel('error');

(() => {
  if (typeof window !== 'undefined') {
    window.vplogger = vpLogger;
    if (isLocalHost() || ['staging', 'preprod'].includes(process.env.REACT_APP_ENVIRONMENT || '')) {
      vpLogger.enableAll();
    }
  }
})();

const originalErrorMethod = vpLogger.error;

vpLogger.error = function (...args) {
  originalErrorMethod.apply(vpLogger, args);

  const message = args.find((arg) => typeof arg === 'string') || 'Error occurred';
  const error = args.find((arg) => arg instanceof Error);

  if (error) {
    Sentry.captureException(error, {
      extra: {
        message: message,
      },
    });
  } else {
    Sentry.captureMessage(message, {
      extra: {
        ...args,
      },
    });
  }
};

export { vpLogger as logger };
